
  <!--
 * 竖版
 * @LastEditTime: Wed Dec 18 2024 22:40:11 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_I6R116" :class="[curLang]" class="u_r_I6R116 route-page"  ><u_c_2BPC42></u_c_2BPC42><u_c_HKLX51></u_c_HKLX51><u_c_P04K62></u_c_P04K62><u_c_G8HA65></u_c_G8HA65></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_2BPC42 from "@/components/u_c_2BPC42.vue";import u_c_HKLX51 from "@/components/u_c_HKLX51.vue";import u_c_P04K62 from "@/components/u_c_P04K62.vue";import u_c_G8HA65 from "@/components/u_c_G8HA65.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"zh-TW":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['zh-TW']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    const init = inject("init", () => {})
init()
    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>
#u_c_TIHK120.normal span {
   display: inline-block;
}
body::-webkit-scrollbar{
      width:0;
      opacity:0;
      -webkit-overflow-scrolling: touch;
}#u_c_TIHK120.normal span {
   display: inline-block;
}
body::-webkit-scrollbar{
      width:0;
      opacity:0;
      -webkit-overflow-scrolling: touch;
}
</style>
